import { useState } from 'react'
import { ConfirmationDialog } from './ConfirmationDialog'

export const useConfirmationDialog = ({
  title,
  text,
  callback,
  deleteConfirmation,
  deleteConfirmationText,
  confirmationText,
}: {
  title?: string
  text: string
  deleteConfirmation?: boolean
  deleteConfirmationText?: string
  confirmationText?: string
  callback?: CallableFunction
}) => {
  const [open, setOpen] = useState<boolean>(false)
  const [callbackState, setCallbackState] = useState(() => callback)
  const closeDialog = () => {
    setOpen(false)
  }
  const requestConfirmation = (callbackOverride?: CallableFunction) => {
    if (callbackOverride) {
      setCallbackState(() => callbackOverride)
    }
    setOpen(true)
  }
  return {
    ConfirmationDialog: (
      <ConfirmationDialog
        text={text}
        title={title}
        callback={callbackState}
        open={open}
        onHandleClose={closeDialog}
        deleteConfirmation={!!deleteConfirmation ? true : false}
        deleteConfirmationText={deleteConfirmationText}
        confirmationText={confirmationText}
      />
    ),
    requestConfirmation,
  }
}
